module.exports = __webpack_public_path__ + "static/media/risk-assessment-grey.0d1aa22f.svg";